import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import Seo from "@/components/Seo";
import { formatApiErrorDetail } from "@/lib/api";

export default function Register() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();
  const { register } = useAuth();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const user = await register(name, email, password);
      toast.success(`Welcome, ${user.name}! We've sent a confirmation email to ${user.email}.`);
      nav("/dashboard");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="container-bl py-14 max-w-md" data-testid="page-register">
      <Seo title="Create account · B&L Rentals" description="Create your account to unlock referral discounts and booking history." />
      <h1 className="text-3xl font-heading font-bold text-white">Create your account</h1>
      <p className="mt-1 text-sm text-[#AEB9C9]">Get a referral code and 10% off your friends' first trips.</p>
      <form onSubmit={submit} className="mt-8 space-y-4">
        <div>
          <Label>Full name</Label>
          <Input required value={name} onChange={(e) => setName(e.target.value)} data-testid="register-name" />
        </div>
        <div>
          <Label>Email</Label>
          <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="register-email" />
        </div>
        <div>
          <Label>Password</Label>
          <Input type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="register-password" />
        </div>
        <Button type="submit" disabled={busy} className="w-full bg-[#E2AB20] hover:bg-[#D89B08] h-11" data-testid="register-submit">
          {busy ? "Creating…" : "Create account"}
        </Button>
      </form>
      <p className="mt-6 text-sm text-[#AEB9C9] text-center">
        Already have one? <Link to="/login" className="link-blue" data-testid="link-login">Sign in</Link>
      </p>
    </div>
  );
}
